export default __webpack_public_path__ + "static/article-commute-etiquette-51d5ef23c3902b1a25a06b3382cae586.jpg";